class HolidaysController {
  /*@ngInject*/
  constructor(Auth, $state, User, $translate, BranchService, Modal, $stateParams, HolidayService, $q, HolidayModal, UserBranchService ,uiCalendarConfig, $scope) {
    this.BranchService = BranchService;
    this.HolidayService = HolidayService;
    this.HolidayModal = HolidayModal;
    this.UserBranchService = UserBranchService;
		this.User = User;    
    this.$q = $q;
    this.uiCalendarConfig = uiCalendarConfig;

    this.branches = [];
    this.holidays = [];
    this.model = {
        branch : this.User.getUser().branchId,
        loggedInUser: User.getUser().id
    };

    this.hasACL = {};

    //full calendar breaks 'this' so declaring this callback as an arrow fn
    this.alertOnEventClick = ( event, jsEvent, view) => {
      const model = {
        id: event.id,
        name: event.title,
        // startDate: event.start,
        // endDate: event.end || event.start, // event.end is null when start and end is same
            startDate: moment.utc(event.start).format('YYYY-MM-DD 12:00:00'),
            endDate: moment.utc(event.end || event.start).format('YYYY-MM-DD 23:59:59'),
            branch: event.branch
      };

      this.HolidayModal.holidayForm(this.hasACL, model, ({$scope, modal}) => { //edit cb
        this.HolidayService.removeGrouped({
          name: event.title, 
          branch: event.branch
        })
        .then(() => {
          return this.HolidayService.createGrouped({
            startDate: model.startDate,
            endDate: model.endDate,
            // startDate: moment.utc($scope.model.startDate ).format('YYYY-MM-DD 00:00:00'),
            // endDate:  moment.utc($scope.model.endDate).format('YYYY-MM-DD 23:59:59'),
            name: $scope.model.name,
            branch: $scope.model.branch[0] // while editing only single branch is selected
          });
        })
        .then(() => {
          return this.loadHolidays();
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => modal.close())
      }, ({modal}) => { //cancel cb
        modal.close();
      }, ({$scope, modal}) => { //delete cb
        this.HolidayService.removeGrouped({
          name: $scope.model.name,
          branch: $scope.model.branch
        })
        .then(() => this.loadHolidays())
        .catch((err) => console.log(err))
        .finally(() => modal.close())
      });
    };
  }
  
  loadHolidays() {
    this.loading = true;

    const searchObj = this.model.branch ? {
      queryJSON: {
        rules: [
          {
            field: 'branchId',
            condition: '=',
            data: this.model.branch
          }
        ],
        operator: 'AND'
      }
    } : null;

    this.HolidayService.getGrouped(searchObj, 0, 100)
    .then((data) => {
      if(data && data.results) {
        this.holidays = [
          data.results.map((holiday) => {
            return {
              title: holiday.name,
              // start: moment(holiday.holidayDate).hours(0).minutes(0).toDate(),
              // end: moment(holiday.holidayEnd).hours(23).minutes(59).toDate(),
              start: moment.utc(holiday.holidayDate).format('YYYY-MM-DD 12:00:00'),
              end: moment.utc(holiday.holidayEnd).format('YYYY-MM-DD 23:59:59'),
              allDay: false,
              //extra data
              branch: holiday.branchId,
            };
          })
        ];
      }
    })
    .finally(() => {
      this.loading = false;
    });
  }

  $onInit() {
    this.loading = true;

    this.uiConfig = {
      calendar:{
        height: 450,
        editable: false,
        header:{
          left: 'title',
          center: '',
          right: 'today prev,next'
        },
        displayEventTime: false,
        eventClick: this.alertOnEventClick,
        loadHolidays: this.loadHolidays()  
      },
    };

    this.acl['setting-holiday'].forEach((permission) => {
      this.hasACL[permission] = true;
    });

    const branchDefer = this.UserBranchService.getUserBranches(this.model.loggedInUser)
    .then((data) => {
      if(data && data.results) {
        this.branches = data.results.map((branch) => {
          return branch.branchId;
        });
      }
    });

    const holidayDefer = this.loadHolidays()
    
    this.$q.all([
      branchDefer,
      holidayDefer 
    ])
    .catch((err) => {
      console.log(err);
    })
  }

  addHoliday() {
    const getHoliday = (name, branch, momentDate) => ({
      name,
      branchId: branch,
      holidayDate: moment.utc(momentDate).format('YYYY-MM-DD 12:00:00')
    });

    this.HolidayModal.holidayForm(this.hasACL, null, ({$scope, modal}) => {

      $scope.model.branch.reduce((p, branch) => {
        const nextIteration = this.$q.defer();

        p.then(() => {
          this.HolidayService.createGrouped({
            startDate: $scope.model.startDate,
            endDate: $scope.model.endDate,
            name: $scope.model.name,
            branch
          })
          .then(() => {
            return nextIteration.resolve();
          })
          .catch((err) => {
            return nextIteration.reject(err);
          });
        });

        return nextIteration.promise;
      }, this.$q.when())
      .then(() => {
        return this.loadHolidays();
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        modal.close();
      });

    }, ({modal}) => {
      modal.close();
    });
  }
}

export default HolidaysController;


// WEBPACK FOOTER //
// ./client/app/components/holiday/holiday.controller.js